import { useLenderOfferAmendment } from "../../components/AmendLenderOfferButton";
import { canAmendOffer } from "../../utils/offerAmendment";
import {
  PROPERTY_LOAN_PROCESSING_FEE_LABEL,
  propertyLoanProcessingFeeTerms,
} from "../../utils/propertyLoanProcessingFee";
import { getPersonData } from "../../utils/myinfoData";
import { Box, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import React, { useState, useEffect, useMemo } from "react";
import { mockDataTeam } from "../../data/mockData";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../../components/Header";
import { Modal, Avatar, Button, message, Input, InputNumber } from "antd";
import Cookies from "js-cookie";
import { format } from "date-fns";
import { useHistory, useLocation } from "react-router-dom";
import { matchesLoanCardName } from "../../utils/loanCardSearch";
import { UserOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";
import TablePendingAcceptance from "../../components/TablePendingAcceptance";
import defaultIcon from "../../assets/img/Profile.png";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFDownloadLink,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import logo from "../../assets/img/SL-01.png";
import boldFont from "../../assets/font/Poppins-SemiBold.ttf";
import LenderBorrowerProfileModal from "../../components/LenderBorrowerProfileModal";

Font.register({
  family: "Poppins",
  fonts: [
    { src: boldFont, fontWeight: 700 }, // Bold (700)
  ],
});

const ContainerActivity2 = ({ noData }) => (
  <div
    style={{
      width: "100%",
      textAlign: "left",
      marginBottom: "12.5px",
      border: "1px solid none",
      borderRadius: "20px",
      backgroundColor: "#FFFFFFB3",
      height: "60px",
    }}
  >
    <p
      style={{
        fontFamily: "Poppins, sans-serif",
        fontWeight: "600",
        fontSize: "16px",
        color: "#142C44CC",
        textAlign: "center",
        paddingTop: "15px",
      }}
    >
      {noData}
    </p>
  </div>
);

const getInitials = (name) => {
  const textToSplit = name.split(" ");
  const initials =
    textToSplit?.[0]?.[0].toUpperCase() +
    (textToSplit?.[1]?.[0].toUpperCase() || "");
  return initials;
};

const parseMaybeJson = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;
  if (typeof value !== "string") return null;

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const getNameFromIdentityPayloads = (payloads = []) => {
  for (const payload of payloads) {
    const parsed = parseMaybeJson(payload);
    const name =
      parsed?.name?.value ||
      getPersonData(parsed)?.name?.value ||
      parsed?.entity?.["basic-profile"]?.["entity-name"]?.value;

    if (name) return name;
  }

  return null;
};

const PendingAcceptance = () => {
  const location = useLocation();
  const pageSearch = new URLSearchParams(location.search).get("search") || "";
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [sortBy, setSortBy] = useState("default");
  const [activeLoanTypeFilter, setActiveLoanTypeFilter] = useState("all");
  const [data, setData] = useState([]);
  const { renderAmendOfferButton, amendmentModal } = useLenderOfferAmendment();
  const [dataActivityLog, setActivityLog] = useState([]);
  const [personalOffers, setPersonalOffers] = useState([]);
  const [propertyOffers, setPropertyOffers] = useState([]);
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalAcceptOfferOpen, setIsModalAcceptOfferOpen] = useState(false);
  const [offer_id, setOfferId] = useState(null);
  const [add_document_description, setAddDocumentDescription] = useState(null);
  const [hovered2, setHovered2] = useState(false);
  const [hovered3, setHovered3] = useState(false);
  const [documentDescriptions, setDocumentDescriptions] = useState([""]);
  const [refreshData, setRefreshData] = useState(false);
  const [screenWidth, setScreenWidth] = useState(() => window.innerWidth);
  const [personalOfferModal, setPersonalOfferModal] = useState({
    open: false,
    offer: null,
  });
  const [personalOfferForm, setPersonalOfferForm] = useState({
    amount: "",
    rate_pa: "",
    tenor_years: "",
  });
  const [personalOfferMessage, setPersonalOfferMessage] = useState("");
  const [personalOfferDocuments, setPersonalOfferDocuments] = useState([""]);
  const [personalOfferBusy, setPersonalOfferBusy] = useState(false);
  const [propertyOfferModal, setPropertyOfferModal] = useState({
    open: false,
    offer: null,
  });
  const [propertyOfferForm, setPropertyOfferForm] = useState({
    amount: "",
    rate_pa: "",
    tenor_years: "",
  });
  const [propertyOfferMessage, setPropertyOfferMessage] = useState("");
  const [propertyOfferDocuments, setPropertyOfferDocuments] = useState([""]);
  const [propertyOfferBusy, setPropertyOfferBusy] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 1200,
  );
  const pendingCorporateOffers = useMemo(
    () =>
      (data || []).filter(
        (item) => item.status !== "accepted" && item.status !== "ongoing",
      ),
    [data],
  );
  const loanTypeCounts = useMemo(
    () => ({
      all:
        pendingCorporateOffers.length +
        personalOffers.length +
        propertyOffers.length,
      corporate: pendingCorporateOffers.length + propertyOffers.length,
      personal: personalOffers.length,
      concierge: 0,
    }),
    [pendingCorporateOffers, personalOffers, propertyOffers],
  );
  useEffect(() => {
    if (screenWidth <= 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  const handleChange = (event, index) => {
    const newDescriptions = [...documentDescriptions];
    newDescriptions[index] = event.target.value;
    setDocumentDescriptions(newDescriptions);
  };

  const addMore = () => {
    setDocumentDescriptions([...documentDescriptions, ""]);
  };

  const remove = (indexToRemove) => {
    setDocumentDescriptions(
      documentDescriptions.filter((_, index) => index !== indexToRemove),
    );
  };

  const handlePersonalDocumentChange = (value, index) => {
    setPersonalOfferDocuments((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  };

  const handlePropertyDocumentChange = (value, index) => {
    setPropertyOfferDocuments((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  };

  const addPersonalDocument = () => {
    setPersonalOfferDocuments((prev) => [...prev, ""]);
  };

  const addPropertyDocument = () => {
    setPropertyOfferDocuments((prev) => [...prev, ""]);
  };

  const removePersonalDocument = (indexToRemove) => {
    setPersonalOfferDocuments((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );
  };

  const removePropertyDocument = (indexToRemove) => {
    setPropertyOfferDocuments((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );
  };

  const openPersonalOfferModal = (offer) => {
    if (!offer) return;
    const offerData = offer.offer_data || {};
    const requestedDocs = (offerData.requested_documents || [])
      .map((doc) => (typeof doc === "string" ? doc : doc?.name))
      .filter(Boolean);
    setPersonalOfferForm({
      amount: offerData.amount ?? "",
      rate_pa: offerData.rate_pa ?? "",
      tenor_years: offerData.tenor_years ?? "",
    });
    setPersonalOfferMessage("");
    setPersonalOfferDocuments(requestedDocs.length ? requestedDocs : [""]);
    setPersonalOfferModal({ open: true, offer });
  };

  const openPropertyOfferModal = (offer) => {
    if (!offer) return;
    const offerData = offer.offer_data || {};
    const requestedDocs = (offerData.requested_documents || [])
      .map((doc) => (typeof doc === "string" ? doc : doc?.name))
      .filter(Boolean);
    setPropertyOfferForm({
      amount: offerData.amount ?? "",
      rate_pa: offerData.rate_pa ?? "",
      tenor_years: offerData.tenor_years ?? "",
    });
    setPropertyOfferMessage("");
    setPropertyOfferDocuments(requestedDocs.length ? requestedDocs : [""]);
    setPropertyOfferModal({ open: true, offer });
  };

  const closePersonalOfferModal = () => {
    setPersonalOfferModal({ open: false, offer: null });
    setPersonalOfferForm({ amount: "", rate_pa: "", tenor_years: "" });
    setPersonalOfferMessage("");
    setPersonalOfferDocuments([""]);
  };

  const closePropertyOfferModal = () => {
    setPropertyOfferModal({ open: false, offer: null });
    setPropertyOfferForm({ amount: "", rate_pa: "", tenor_years: "" });
    setPropertyOfferMessage("");
    setPropertyOfferDocuments([""]);
  };

  const submitPersonalOfferUpdate = async () => {
    if (!personalOfferModal.offer) return;
    try {
      setPersonalOfferBusy(true);
      const requested_documents = personalOfferDocuments
        .map((doc) => (doc || "").trim())
        .filter(Boolean)
        .map((doc) => ({ name: doc }));
      const response = await fetch(
        "https://www.smart-lend.com/api/personalLoans/offers/upsert",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            id: personalOfferModal.offer.id,
            personal_loan_request_id:
              personalOfferModal.offer.personal_loan_request_id,
            offer_data: {
              ...personalOfferModal.offer.offer_data,
              amount: Number(personalOfferForm.amount),
              rate_pa: Number(personalOfferForm.rate_pa),
              tenor_years: Number(personalOfferForm.tenor_years),
              requested_documents,
            },
            lender_message: personalOfferMessage || null,
          }),
        },
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to update offer.");
      }

      message.success("Money Lender loan offer updated.");
      closePersonalOfferModal();
      setRefreshData((prev) => !prev);
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to update offer.");
    } finally {
      setPersonalOfferBusy(false);
    }
  };

  const submitPropertyOfferUpdate = async () => {
    if (!propertyOfferModal.offer) return;
    try {
      setPropertyOfferBusy(true);
      const requested_documents = propertyOfferDocuments
        .map((doc) => (doc || "").trim())
        .filter(Boolean)
        .map((doc) => ({ name: doc }));
      const response = await fetch(
        "https://www.smart-lend.com/api/propTermLoan/createPropLoanOffers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            id: propertyOfferModal.offer.id,
            prop_loan_request_id: propertyOfferModal.offer.prop_loan_request_id,
            offer_data: {
              ...propertyOfferModal.offer.offer_data,
              amount: Number(propertyOfferForm.amount),
              ...propertyLoanProcessingFeeTerms(propertyOfferForm.amount),
              rate_pa: Number(propertyOfferForm.rate_pa),
              tenor_years: Number(propertyOfferForm.tenor_years),
              requested_documents,
            },
            lender_message: propertyOfferMessage || null,
          }),
        },
      );

      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to update offer.");
      }

      message.success("Property loan offer updated.");
      closePropertyOfferModal();
      setRefreshData((prev) => !prev);
    } catch (error) {
      console.error(error);
      message.error(error.message || "Unable to update offer.");
    } finally {
      setPropertyOfferBusy(false);
    }
  };

  const handleDownloadAdditionalFile = async (offer_id, loan_id, event) => {
    event.preventDefault();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/viewApplicantDocument?offer_id=${offer_id}&loan_id=${loan_id}`,
        options,
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      if (data && data.data) {
        window.open(data.data, "_blank"); // open the url in a new tab
      }
    } catch (error) {
      console.error(error);
    }
  };

  const showModalRequestDocument = (offer_id, express) => {
    setIsModalOpen(true);
    setOfferId(offer_id);
    setDocumentDescriptions([""]);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModalAcceptOffer = (offer_id, express) => {
    setIsModalAcceptOfferOpen(true);
    setOfferId(offer_id);
    setDocumentDescriptions([""]);
  };

  const handleAcceptOfferOk = () => {
    setIsModalAcceptOfferOpen(false);
  };

  const handleAcceptOfferCancel = () => {
    setIsModalAcceptOfferOpen(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-"; // Return a default value if the date string is not provided

    const date = new Date(dateString); // Create a Date object from the date string
    const formattedDate = format(date, "MMM dd, yyyy"); // Use date-fns to format the date in the desired format

    return formattedDate;
  };

  const formatCurrency = (value) => {
    if (value === undefined || value === null || value === "") return "-";
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    return numeric.toLocaleString("en-SG", {
      style: "currency",
      currency: "SGD",
    });
  };

  const getBorrowerAdjustedDetails = (offerData) => {
    const originalAmount = Number(offerData?.original_amount || 0);
    const currentAmount = Number(offerData?.amount || 0);
    if (!offerData?.borrower_adjusted || !originalAmount || !currentAmount) {
      return null;
    }
    if (currentAmount >= originalAmount) return null;
    return { originalAmount, currentAmount };
  };

  const getPersonalOfferBorrowerName = (offer) =>
    getNameFromIdentityPayloads([
      offer?.request?.myinfo_data,
      offer?.request?.borrower?.myinfo_data,
      offer?.borrower_summary?.myinfo_data,
      offer?.request?.borrower_summary?.myinfo_data,
    ]) ||
    offer?.borrower_summary?.name ||
    offer?.request?.borrower?.entity_name ||
    offer?.request?.borrower?.principal_name ||
    offer?.request?.principal_name ||
    offer?.request?.contact_email ||
    "Borrower";

  const getCompanyOfferBorrowerName = (offer) =>
    offer?.borrower_summary?.name ||
    offer?.request?.borrower_data?.entity_name ||
    offer?.request?.borrower_data?.principal_name ||
    offer?.request?.borrower?.entity_name ||
    offer?.request?.borrower?.principal_name ||
    offer?.request?.principal_name ||
    getNameFromIdentityPayloads([
      offer?.request?.borrower?.singpass_data,
      offer?.request?.borrower?.myinfo_data,
      offer?.request?.singpass_data,
      offer?.request?.myinfo_data,
    ]) ||
    "Borrower";

  const getCorporateLoanName = (loan) =>
    loan?.principal_name ||
    loan?.borrower_name ||
    loan?.borrower_details?.entity_name ||
    loan?.borrower_details?.principal_name ||
    getNameFromIdentityPayloads([
      loan?.borrower_details?.singpass_data,
      loan?.singpass_data,
    ]) ||
    "Borrower";

  const normalizePropertyLoanData = (loanData) => {
    if (!loanData) return {};
    if (typeof loanData === "string") {
      try {
        return JSON.parse(loanData);
      } catch (error) {
        return {};
      }
    }
    return loanData || {};
  };

  const getPropertyLoanTypeLabel = (loanData) => {
    const selected = Number(loanData?.selectedLoanType);
    if (selected === 0) return "First Charge Equity Term Loan";
    if (selected === 1) return "Bridging Loan";
    return "Property Term Loan";
  };

  const getInitials = (name) => {
    const textToSplit = name.split(" ");
    const initials =
      textToSplit?.[0]?.[0].toUpperCase() +
      (textToSplit?.[1]?.[0].toUpperCase() || "");
    return initials;
  };

  const Container = ({
    icon,
    title,
    subtitle,
    label,
    description,
    label1,
    label2,
    description1,
    description2,
    label3,
    description3,
    label4,
    description4,
    index,
    loan_id,
    offer_id,
    label5,
    description5,
    createdAt,
    item,
  }) => {
    const shouldAddMarginTop = index > 3;
    const [hovered, setHovered] = useState(false);

    return (
      <>
        <div
          className="sl-rebrand-loan-card sl-pending-loan-card"
          style={{
            width: "100%",
            textAlign: "center",
            border: "none",
            borderRadius: "10px",
            backgroundColor: "#FFFFFFB3",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: screenWidth > 1200 ? "40vh" : "auto",
            padding: "15px",
            position: "relative",
            cursor: "pointer",
          }}
          onClick={(event) => {
            event.stopPropagation();
            setSelectedBorrowerProfile({ loanType: "corporate", loan: item, borrowerName: title });
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  background: "rgb(140,140,170)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "white",
                  fontSize: 20,
                  fontWeight: 600,
                  position: "relative",
                }}
                role="button"
                tabIndex={0}
                aria-label={`View ${title}'s profile`}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    event.currentTarget.click();
                  }
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  setSelectedBorrowerProfile({ loanType: "corporate", loan: item, borrowerName: title });
                }}
                className="sl-loan-avatar"
              >
                {title ? getInitials(title) : "SL"}
                {item.badge_verified ? (
                  <div
                    className="tooltip-container"
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "rgb(14, 90, 165)",
                    }}
                  >
                    <LocalPoliceIcon
                      className="tooltip-target"
                      style={{ color: "white", fontSize: "14px" }}
                    />
                    <span className="tooltip-text">
                      Verified borrowers have undergone SmartLend's
                      authentication process, demonstrating legitimate business
                      operations. This includes providing evidence such as
                      current tenancy agreements, business premises signage, or
                      recent invoices matching their bank statements
                    </span>
                  </div>
                ) : null}
              </div>
              <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
                <h3
                  style={{
                    fontWeight: "700",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "16px",
                    color: "#142C44CC",
                    textAlign: "left",
                    margin: "0px",
                  }}
                >
                  {isMobile
                    ? title.length > 23
                      ? title.slice(0, 23) + "..."
                      : title
                    : title}
                </h3>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.4)",
                    textAlign: "left",
                    margin: "0px",
                  }}
                >
                  {item.badge_verified ? subtitle : null}
                </p>
              </div>
            </div>
            <div className="sl-loan-card-body">
              <div className="sl-amount-block">
                <span className="sl-field-label">Requested amount</span>
                <div className="sl-loan-amount">{description}</div>
              </div>
              <div className="sl-field-grid">
                <div className="sl-field">
                  <p className="sl-field-label">Preferred rate</p>
                  <p className="sl-field-value">{description4}</p>
                </div>
                <div className="sl-field">
                  <p className="sl-field-label">Preferred tenor</p>
                  <p className="sl-field-value">{description2}</p>
                </div>
                <div className="sl-field">
                  <p className="sl-field-label">Processing fee</p>
                  <p className="sl-field-value">
                    {(item.processing_fee * 100).toFixed(1) + "%"}
                  </p>
                </div>
              </div>
              <div className="sl-pending-card-status">
                <span className="sl-field-label">{label3}</span>
                <strong>{description3}</strong>
              </div>
              <div className="sl-loan-card-meta">
                <span>Applied {formatDate(createdAt)}</span>
                <span>Monthly receivables {description1}</span>
              </div>
              {description3 === "Rejected" ? (
                <div className="sl-loan-card-meta">
                  <span>Updated {formatDate(item.updated_at)}</span>
                </div>
              ) : null}

              {description3 === "Rejected" && item.reason_id !== null ? (
                <div className="sl-card-detail-block sl-card-detail-block-soft">
                  <span className="sl-card-detail-label">Rejected reason</span>
                  <p>
                    {item.reason_id
                      ? item.reason_id === "0"
                        ? "I have a better rate from another lender"
                        : item.reason_id === "1"
                          ? "The offer doesnt meet my requirements"
                          : item.reason_id === "2"
                            ? "The rates are too high"
                            : item.reason_id === "3"
                              ? "I no longer need a loan"
                              : null
                      : null}
                  </p>
                </div>
              ) : null}

              {label5 || description5 ? (
                <div className="sl-loan-card-meta">
                  <span>{label5}</span>
                  <span>{description5}</span>
                </div>
              ) : null}
            </div>
          </div>
          <div className="sl-loan-card-actions">
            {renderAmendOfferButton({ loanType: "corporate", offer: item, onUpdated: () => setRefreshData((prev) => !prev) })}
            <button
              className="all_button sl-card-primary-action"
              style={{
                background: "#7057F6",
                color: "white",
                width: "100%",
                border: "none",
                borderRadius: "50px",
                padding: "6px 0px",
                fontSize: "12px",
                margin: "10px 0px 0px 0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onMouseEnter={() => setHovered(true)} // set the state hovered to true  when mouse enter
              onMouseLeave={() => setHovered(false)} // set the state hovered to false  when mouse leave
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                showModal(loan_id, event);
              }}
            >
              View Offer
            </button>
            <button
              className="all_button"
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                // console.log(item)
                const url = `/l-messages?principelname=${item.principal_name}&userid=${item.borrower_id}&requestamount=${item.offer_amount}`;
                history.push(url);
              }}
              style={{
                background: "transparent",
                color: "grey",
                width: "100%",
                border: "2px solid lightgrey",
                borderRadius: "15px",
                padding: "4px 20px",
                fontSize: "12px",
                marginTop: "10px",
              }}
            >
              Message borrower
            </button>
          </div>
        </div>
      </>
    );
  };

  const PersonalOfferCard = ({ offer }) => {
    const offerData = offer.offer_data || {};
    const borrowerAdjusted = getBorrowerAdjustedDetails(offerData);
    const borrowerName = getPersonalOfferBorrowerName(offer);
    const borrowerId =
      offer.borrower_summary?.user_id || offer.request?.user_id;
    const normalizedBorrowerId = borrowerId ? String(borrowerId) : "";
    const requestedDocuments = (offerData.requested_documents || [])
      .map((doc) => (typeof doc === "string" ? doc : doc?.name))
      .filter(Boolean);
    const supportingDocs = (offer.documents || []).filter((doc) => {
      const isRequestedDoc =
        doc.stage === "supporting" ||
        doc?.metadata?.requested_document ||
        (doc?.notes && requestedDocuments.includes(doc.notes));
      if (!isRequestedDoc) return false;

      const docUserId = doc?.user_id ? String(doc.user_id) : "";
      return doc?.role === "borrower" ||
        (normalizedBorrowerId && docUserId === normalizedBorrowerId)
        ? true
        : false;
    });
    const supportingDocsByRequest = supportingDocs.reduce((acc, doc) => {
      const key =
        doc?.metadata?.requested_document || doc?.notes || "Other documents";
      if (!acc[key]) acc[key] = [];
      acc[key].push(doc);
      return acc;
    }, {});

    return (
      <div
        className="sl-rebrand-loan-card sl-pending-loan-card sl-personal-loan-card"
        style={{
          width: "100%",
          textAlign: "center",
          borderRadius: "10px",
          backgroundColor: "#FFFFFFB3",
          border: "1px solid rgba(214, 51, 132, 0.35)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: screenWidth > 1200 ? "40vh" : "auto",
          padding: "15px",
          position: "relative",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "0px",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              role="button"
              tabIndex={0}
              aria-label={`View ${borrowerName}'s profile`}
              onClick={(event) => {
                event.stopPropagation();
                setSelectedBorrowerProfile({ loanType: "personal", loan: { ...offer.request, borrower_summary: offer.borrower_summary }, borrowerName });
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  event.currentTarget.click();
                }
              }}
              className="sl-loan-avatar sl-loan-avatar-pink"
              style={{
                cursor: "pointer",
                width: "55px",
                height: "55px",
                borderRadius: "50%",
                background: "rgb(214, 51, 132)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                fontSize: 20,
                fontWeight: 600,
              }}
            >
              {borrowerName ? getInitials(borrowerName) : "SL"}
            </div>
            <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
              <h3
                style={{
                  fontWeight: "700",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "16px",
                  color: "#142C44CC",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                {borrowerName.length > 20
                  ? borrowerName.slice(0, 20) + "..."
                  : borrowerName}
              </h3>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(214, 51, 132, 0.7)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                Money Lender Loan
              </p>
            </div>
          </div>

          <div className="sl-loan-card-body">
            <div className="sl-amount-block">
              <span className="sl-field-label">Requested amount</span>
              <div className="sl-loan-amount">
                {formatCurrency(offerData.amount)}
              </div>
            </div>
            {borrowerAdjusted && (
              <p
                className="sl-card-inline-note sl-card-inline-note-pink"
              >
                Borrower accepted{" "}
                {formatCurrency(borrowerAdjusted.currentAmount)} instead of{" "}
                {formatCurrency(borrowerAdjusted.originalAmount)}.
              </p>
            )}
            <div className="sl-field-grid">
              <div className="sl-field">
                <p className="sl-field-label">Preferred rate</p>
                <p className="sl-field-value">
                  {offerData.rate_pa !== undefined
                    ? `${offerData.rate_pa}% p.a.`
                    : "-"}
                </p>
              </div>
              <div className="sl-field">
                <p className="sl-field-label">Preferred tenor</p>
                <p className="sl-field-value">
                  {offerData.tenor_years
                    ? `${offerData.tenor_years * 12} mo`
                    : "-"}
                </p>
              </div>
              <div className="sl-field">
                <p className="sl-field-label">Processing fee</p>
                <p className="sl-field-value">10%</p>
              </div>
            </div>
            <div className="sl-pending-card-status">
              <span className="sl-field-label">Status</span>
              <strong>
                {offer.status === "borrower_rejected" ? "Borrower rejected" : offer.status === "borrower_renegotiation"
                  ? "Borrower requested changes"
                  : "Awaiting borrower response"}
              </strong>
            </div>
          </div>

          {offer.borrower_notes && (
            <div className="sl-card-detail-block">
              <span className="sl-card-detail-label">Borrower note</span>
              <p>{offer.borrower_notes}</p>
            </div>
          )}

          {requestedDocuments.length > 0 && (
            <div className="sl-card-detail-block">
              <span className="sl-card-detail-label">Requested documents</span>
              <div className="sl-card-chip-list">
                {requestedDocuments.map((doc) => (
                  <span key={`${offer.id}-${doc}`}>{doc}</span>
                ))}
              </div>
            </div>
          )}

          {Object.keys(supportingDocsByRequest).length > 0 && (
            <div className="sl-card-detail-block">
              <span className="sl-card-detail-label">
                Borrower uploaded documents
              </span>
              <div className="sl-card-doc-list">
                {Object.entries(supportingDocsByRequest).map(([key, docs]) => (
                  <div key={`${offer.id}-supporting-${key}`}>
                    <strong>{key}</strong>
                    {docs.map((doc) => (
                      <a
                        key={doc.id}
                        href={doc.file_url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {doc.file_name || "View document"}
                      </a>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="sl-loan-card-actions">
          <Button
            className="all_button sl-card-primary-action sl-personal-primary-action"
            type="primary"
            disabled={!canAmendOffer("personal", offer)}
            onClick={() => openPersonalOfferModal(offer)}
            style={{
              background: "#d63384",
              borderColor: "#d63384",
              width: "100%",
              borderRadius: "30px",
            }}
          >
            Amend offer
          </Button>
          <Button
            className="all_button"
            type="default"
            onClick={() => {
              if (!borrowerId) return;
              const url = `/l-messages?principelname=${borrowerName}&userid=${borrowerId}&requestamount=${offerData.amount}`;
              history.push(url);
            }}
            style={{ width: "100%", marginTop: "10px", borderRadius: "30px" }}
          >
            Message borrower
          </Button>
        </div>
      </div>
    );
  };

  const PropertyOfferCard = ({ offer }) => {
    const offerData = offer.offer_data || {};
    const borrowerAdjusted = getBorrowerAdjustedDetails(offerData);
    const borrowerName = getCompanyOfferBorrowerName(offer);
    const borrowerId =
      offer.borrower_summary?.user_id || offer.request?.user_id;
    const requestedDocuments = (offerData.requested_documents || [])
      .map((doc) => (typeof doc === "string" ? doc : doc?.name))
      .filter(Boolean);
    const borrowerDocuments = (offer.documents || []).filter(
      (doc) => doc.role === "borrower",
    );
    const supportingDocs = borrowerDocuments.filter(
      (doc) => doc.stage === "supporting",
    );
    const supportingDocsByRequest = supportingDocs.reduce((acc, doc) => {
      const key =
        doc?.metadata?.requested_document || doc?.notes || "Other documents";
      if (!acc[key]) acc[key] = [];
      acc[key].push(doc);
      return acc;
    }, {});
    const requestLoanData = normalizePropertyLoanData(offer.request?.loan_data);

    return (
      <div
        className="sl-rebrand-loan-card sl-pending-loan-card sl-property-loan-card"
        style={{
          width: "100%",
          textAlign: "center",
          borderRadius: "10px",
          backgroundColor: "#FFFFFFB3",
          border: "1px solid rgba(47, 158, 68, 0.35)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: screenWidth > 1200 ? "40vh" : "auto",
          padding: "15px",
          position: "relative",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "0px",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              role="button"
              tabIndex={0}
              aria-label={`View ${borrowerName}'s profile`}
              onClick={(event) => {
                event.stopPropagation();
                setSelectedBorrowerProfile({ loanType: "property", loan: { ...offer.request, borrower_summary: offer.borrower_summary }, borrowerName });
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  event.currentTarget.click();
                }
              }}
              className="sl-loan-avatar sl-loan-avatar-green"
              style={{
                cursor: "pointer",
                width: "55px",
                height: "55px",
                borderRadius: "50%",
                background: "#2f9e44",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                fontSize: 20,
                fontWeight: 600,
              }}
            >
              {borrowerName ? getInitials(borrowerName) : "SL"}
            </div>
            <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
              <h3
                style={{
                  fontWeight: "700",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "16px",
                  color: "#142C44CC",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                {borrowerName.length > 20
                  ? borrowerName.slice(0, 20) + "..."
                  : borrowerName}
              </h3>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(47, 158, 68, 0.7)",
                  textAlign: "left",
                  margin: "0px",
                }}
              >
                {getPropertyLoanTypeLabel(requestLoanData)}
              </p>
            </div>
          </div>

          <div className="sl-loan-card-body">
            <div className="sl-amount-block">
              <span className="sl-field-label">Requested amount</span>
              <div className="sl-loan-amount">
                {formatCurrency(offerData.amount)}
              </div>
            </div>
            {borrowerAdjusted && (
              <p
                className="sl-card-inline-note sl-card-inline-note-pink"
              >
                Borrower accepted{" "}
                {formatCurrency(borrowerAdjusted.currentAmount)} instead of{" "}
                {formatCurrency(borrowerAdjusted.originalAmount)}.
              </p>
            )}
            <div className="sl-field-grid">
              <div className="sl-field">
                <p className="sl-field-label">Preferred rate</p>
                <p className="sl-field-value">
                  {offerData.rate_pa !== undefined
                    ? `${offerData.rate_pa}% p.a.`
                    : "-"}
                </p>
              </div>
              <div className="sl-field">
                <p className="sl-field-label">Preferred tenor</p>
                <p className="sl-field-value">
                  {offerData.tenor_years
                    ? `${offerData.tenor_years * 12} mo`
                    : "-"}
                </p>
              </div>
              <div className="sl-field">
                <p className="sl-field-label">Processing fee</p>
                <p className="sl-field-value">{PROPERTY_LOAN_PROCESSING_FEE_LABEL}</p>
              </div>
            </div>
            <div className="sl-pending-card-status">
              <span className="sl-field-label">Status</span>
              <strong>
                {offer.status === "borrower_rejected" ? "Borrower rejected" : offer.status === "borrower_renegotiation"
                  ? "Borrower requested changes"
                  : "Awaiting borrower response"}
              </strong>
            </div>
          </div>

          {offer.borrower_notes && (
            <div className="sl-card-detail-block">
              <span className="sl-card-detail-label">Borrower note</span>
              <p>{offer.borrower_notes}</p>
            </div>
          )}

          {requestedDocuments.length > 0 && (
            <div className="sl-card-detail-block">
              <span className="sl-card-detail-label">Requested documents</span>
              <div className="sl-card-chip-list">
                {requestedDocuments.map((doc) => (
                  <span key={`${offer.id}-${doc}`}>{doc}</span>
                ))}
              </div>
            </div>
          )}

          {Object.keys(supportingDocsByRequest).length > 0 && (
            <div className="sl-card-detail-block">
              <span className="sl-card-detail-label">Borrower uploads</span>
              <div className="sl-card-doc-list">
                {Object.entries(supportingDocsByRequest).map(([key, docs]) => (
                  <div key={`${offer.id}-supporting-${key}`}>
                    <strong>{key}</strong>
                    {docs.map((doc) => (
                      <a
                        key={doc.id}
                        href={doc.file_url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {doc.file_name || "View document"}
                      </a>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="sl-loan-card-actions">
          <Button
            className="all_button sl-card-primary-action sl-property-primary-action"
            type="primary"
            disabled={!canAmendOffer("property", offer)}
            onClick={() => openPropertyOfferModal(offer)}
            style={{
              background: "#2f9e44",
              borderColor: "#2f9e44",
              width: "100%",
              borderRadius: "30px",
            }}
          >
            Amend offer
          </Button>
          <Button
            className="all_button"
            type="default"
            onClick={() => {
              if (!borrowerId) return;
              const url = `/l-messages?principelname=${borrowerName}&userid=${borrowerId}&requestamount=${offerData.amount}`;
              history.push(url);
            }}
            style={{ width: "100%", marginTop: "10px", borderRadius: "30px" }}
          >
            Message borrower
          </Button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    // To redirect user if not authenticated
    const isAuthenticated = Cookies.get("token");
    const user_account_type = Cookies.get("user_account_type");

    if (!isAuthenticated) {
      history.push("/auth/signin");
    } else if (user_account_type === "borrower") {
      history.push("/b-dashboard");
    }
  }, [history]);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/loan/viewPendingAcceptance",
          options,
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        const parsedData = data["Pending Loan"].map((item) => {
          const updatedItem = {
            ...item,
            credit_report_data: parseMaybeJson(item.credit_report_data) || {},
          };

          return updatedItem;
        });

        setData(parsedData);
        console.log("Fetched data:", data["Pending Loan"]); // to ensure data is fetched properly
      } catch (error) {
        console.error(error);
      }
    }
    async function fetchPersonalOffers() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/personalLoans/offers/pending",
          {
            method: "GET",
            headers,
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch personal loan offers");
        }

        const json = await response.json();
        setPersonalOffers(json.data || []);
      } catch (error) {
        console.error(error);
      }
    }
    async function fetchPropertyOffers() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/propTermLoan/offers/pending",
          {
            method: "GET",
            headers,
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch property loan offers");
        }

        const json = await response.json();
        setPropertyOffers(json.data || []);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
    fetchPersonalOffers();
    fetchPropertyOffers();
  }, [refreshData]);

  useEffect(() => {
    const initialStates = {};
    data.forEach((item) => {
      initialStates[item.loan_id] = false;
    });
    setModalStates(initialStates);
  }, [data]);

  const [modalStates, setModalStates] = useState({});

  const [open, setOpen] = useState(false);

  const showModal = async (loanId, event) => {
    event.preventDefault();
    console.log("loanId modal", loanId);
    setModalStates((prevStates) => ({
      ...prevStates,
      [loanId]: true,
    }));

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/loanRequest/loanView?loan_id=${loanId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Success:", data);
      } else {
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleRequestMoreDocument = async (
    offer_id,
    add_document_description,
  ) => {
    try {
      const filteredDescriptions = add_document_description.filter(
        (description) => description.trim() !== "",
      );

      const response = await fetch(
        `https://www.smart-lend.com/api/loan/requestAddDocument`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify({
            offer_id: offer_id,
            document_names: filteredDescriptions,
          }),
        },
      );
      const data = await response.json();

      if (response.status === 200) {
        message.success("Additional document request successfully!");
        setIsModalOpen(false);
        setRefreshData((prevState) => !prevState); // Change the state, triggering useEffect
      } else if (response.status === 400) {
        message.error("Documents with the same names already exist.");
      }
    } catch (error) {
      console.error("Error creating offer:", error);
      message.error("Error requesting additional document");
    }
  };

  const handleAllowAcceptOffer = async (offer_id) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/allowAcceptOffer?offer_id=${offer_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        },
      );
      const data = await response.json();
      if (response.status === 200) {
        message.success("Borrower had been allowed to accept the offer");
        setIsModalAcceptOfferOpen(false);
        setRefreshData((prevState) => !prevState); // Change the state, triggering useEffect
      }
    } catch (error) {
      console.error("Error creating offer:", error);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/profile/viewActivityLog",
          options,
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        // Reverse the order of the processedData
        const reversedData = data.reverse();

        setActivityLog(reversedData);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  const ContainerActivity = ({ title, subtitle, index }) => (
    <article className="sl-activity-event">
      <div
        className={`sl-activity-event-icon ${
          index === 1 ? "green" : index === 2 ? "" : "blue"
        }`}
      >
        {index === 1 ? "✓" : index === 2 ? "▧" : "↗"}
      </div>
      <div className="sl-activity-event-body">
        <div className="sl-activity-event-top">
          <h3>{title}</h3>
          <span>{index === 0 ? "Now" : index === 1 ? "Today" : "Recent"}</span>
        </div>
        <p>{subtitle}</p>
        <div className="sl-activity-event-meta">
          <span>{title ? getInitials(title) : "SL"}</span>
          <span>View activity</span>
        </div>
      </div>
    </article>
  );

  const ContainerLineChart = () => (
    <div className="sl-mini-chart-card sl-mini-chart-card-dark">
      <div className="sl-mini-chart-head">
        <div>
          <span>Net profit</span>
          <strong>4.0%</strong>
        </div>
        <em>+0.8%</em>
      </div>
      <div className="sl-mini-line">
        <svg viewBox="0 0 260 96" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id="slPendingRailA" x1="0" x2="0" y1="0" y2="1">
              <stop stopColor="#8B6CFF" stopOpacity=".42" />
              <stop offset="1" stopColor="#8B6CFF" stopOpacity="0" />
            </linearGradient>
          </defs>
          <path
            d="M6 68 C42 32 76 78 112 48 S184 22 254 36 L254 96 L6 96 Z"
            fill="url(#slPendingRailA)"
          />
          <path
            d="M6 68 C42 32 76 78 112 48 S184 22 254 36"
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M6 68 C42 32 76 78 112 48 S184 22 254 36"
            fill="none"
            stroke="#8B6CFF"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <p>Portfolio yield trend</p>
    </div>
  );

  const ContainerPieChart = () => (
    <div className="sl-mini-chart-card">
      <div className="sl-mini-chart-head">
        <div>
          <span>Forecast collection</span>
          <strong>$116,250</strong>
        </div>
      </div>
      <div className="sl-donut-chart">
        <svg viewBox="0 0 120 120" aria-hidden="true">
          <defs>
            <linearGradient id="slPendingDonutA" x1="0" x2="1">
              <stop stopColor="#7057F6" />
              <stop offset="1" stopColor="#285B9F" />
            </linearGradient>
          </defs>
          <circle
            cx="60"
            cy="60"
            r="48"
            fill="none"
            stroke="#EEF1FB"
            strokeWidth="16"
          />
          <circle
            cx="60"
            cy="60"
            r="48"
            fill="none"
            stroke="url(#slPendingDonutA)"
            strokeWidth="16"
            strokeLinecap="round"
            strokeDasharray="182 302"
            transform="rotate(-90 60 60)"
          />
        </svg>
        <div>
          <strong>60%</strong>
          <span>collected</span>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [dppicture, setdppicture] = useState([]);

  const fillAllLenderPpicture = async (index, lenderId) => {
    // try {
    //   const response = await fetch(
    //     `https://www.smart-lend.com/api/user/getLenderPicture?lender_id=${lenderId}`,
    //     {
    //       method: "GET",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${Cookies.get("token")}`,
    //       },
    //     }
    //   );
    //   const blob = await response.blob();
    //   const imageUrl = URL.createObjectURL(blob);
    //   setdppicture((prevDppicture) => {
    //     const updatedDppicture = [...prevDppicture]; // Create a copy of the array
    //     updatedDppicture[index] = { profilepicture: imageUrl }; // Update the specific index
    //     console.log(updatedDppicture);
    //     return updatedDppicture;
    //   });
    // } catch (error) {
    //   console.error(error);
    // }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      data

        .sort((a, b) => {
          if (sortBy === "loan-amount") {
            return a.offer_amount - b.offer_amount;
          } else if (sortBy === "date") {
            return new Date(a.created_at) - new Date(b.created_at);
          } else {
            // Default sorting option
            return new Date(b.created_at) - new Date(a.created_at);
          }
        })
        .map((item, index) => {
          if (item.status !== "accepted" && item.status !== "ongoing") {
            console.log(item);
            fillAllLenderPpicture(index, item.borrower_id);
          }
        });
    }
  }, [data, sortBy]);
  const [selectedBorrowerProfile, setSelectedBorrowerProfile] = useState(null);

  const getPendingEntryAmount = (entry) => {
    if (entry.type === "corporate") return Number(entry.offer?.offer_amount || 0);
    return Number(entry.offer?.offer_data?.amount || 0);
  };

  const getPendingEntryDate = (entry) =>
    new Date(entry.offer?.created_at || entry.offer?.updated_at || 0);

  const pendingLoanEntries = [
    ...pendingCorporateOffers.map((offer, index) => ({
      type: "corporate",
      offer,
      index,
    })),
    ...personalOffers.map((offer) => ({
      type: "personal",
      offer,
    })),
    ...propertyOffers.map((offer) => ({
      type: "property",
      offer,
    })),
  ]
    .filter((entry) => {
      const name = entry.type === "corporate"
        ? getCorporateLoanName(entry.offer)
        : entry.type === "personal"
        ? getPersonalOfferBorrowerName(entry.offer)
        : getCompanyOfferBorrowerName(entry.offer);
      return matchesLoanCardName(name, pageSearch);
    })
    .filter((entry) => {
      if (activeLoanTypeFilter === "all") return true;
      if (activeLoanTypeFilter === "personal") return entry.type === "personal";
      if (activeLoanTypeFilter === "corporate") {
        return entry.type === "corporate" || entry.type === "property";
      }
      return false;
    })
    .sort((a, b) => {
      if (sortBy === "loan-amount") {
        return getPendingEntryAmount(b) - getPendingEntryAmount(a);
      }
      return getPendingEntryDate(b) - getPendingEntryDate(a);
    });

  const renderPendingLoanEntry = (entry) => {
    if (entry.type === "personal") {
      return <PersonalOfferCard key={`personal-${entry.offer.id}`} offer={entry.offer} />;
    }

    if (entry.type === "property") {
      return <PropertyOfferCard key={`property-${entry.offer.id}`} offer={entry.offer} />;
    }

    const item = entry.offer;
    const index = entry.index || 0;
    const corporateBorrowerName = getCorporateLoanName(item);

    return (
      <Container
        key={`corporate-${item.id || item.loan_id}`}
        icon="https://cdn.pixabay.com/photo/2018/05/08/21/28/apple-3384010_960_720.png"
        title={corporateBorrowerName}
        subtitle={item.express === 1 ? "Express Applicant" : "Approved Borrower"}
        label="Loan Amount"
        description={
          item.offer_amount
            ? item.offer_amount.toLocaleString("en-US", {
                style: "currency",
                currency: "SGD",
              })
            : "-"
        }
        label1="Monthly Receivables"
        createdAt={item.created_at}
        description1={
          item.offer_monthly_installment
            ? item.offer_monthly_installment.toLocaleString("en-US", {
                style: "currency",
                currency: "SGD",
              })
            : "-"
        }
        label2="Period"
        description2={item.offer_period + " Months" || "-"}
        label3="Loan Status"
        description3={
          item.status === "not_available"
            ? "Not Available"
            : item.status === "pending_document_request"
            ? "Pending Document Request"
            : item.status
            ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
            : "-"
        }
        label4="Interest Rate Per Month"
        description4={(item.offer_interest_rate * 100).toFixed(1) + " %" || "-"}
        index={index}
        loan_id={item.loan_id}
        offer_id={item.id}
        open_modal={modalStates[item.loan_id]}
        onClickModal={(event) => showModal(item.loan_id, event)}
        cancel_modal={() => handleClose(item.loan_id)}
        item={item}
      />
    );
  };

  return (
    <Box className="sl-loan-request-shell" m="0 24px 32px 36px">
      {amendmentModal}
      {selectedBorrowerProfile && (
        <LenderBorrowerProfileModal
          key={`${selectedBorrowerProfile.loanType}-${selectedBorrowerProfile.loan.loan_id || selectedBorrowerProfile.loan.id}`}
          {...selectedBorrowerProfile}
          isMobile={isMobile}
          onClose={() => setSelectedBorrowerProfile(null)}
        />
      )}
      <Modal
        className="sl-loan-action-modal sl-personal-loan-modal"
        open={personalOfferModal.open}
        onCancel={closePersonalOfferModal}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
              gap: 8,
            }}
          >
            <Button
              type="primary"
              loading={personalOfferBusy}
              onClick={submitPersonalOfferUpdate}
            >
              Update offer
            </Button>
            <Button type="default" onClick={closePersonalOfferModal}>
              Cancel
            </Button>
          </div>,
        ]}
      >
        <div className="sl-loan-modal-head">
          <div className="sl-loan-modal-title">
            <div className="sl-loan-modal-mark pink">
              {getInitials(
                personalOfferModal.offer
                  ? getPersonalOfferBorrowerName(personalOfferModal.offer)
                  : "ML",
              ).slice(0, 2)}
            </div>
            <div>
              <h2>Money Lender Offer</h2>
              <p>Update the offer terms and document requests.</p>
            </div>
          </div>
        </div>
        <div className="sl-loan-modal-grid">
          <div className="sl-loan-modal-panel">
            <h3>Offer terms</h3>
            <div className="sl-loan-modal-fields">
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Offer amount</div>
            <InputNumber
              style={{ width: "100%" }}
              value={personalOfferForm.amount}
              min={1000}
              max={200000}
              formatter={(value) =>
                `S$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/S\$\s?|(,*)/g, "")}
              onChange={(value) =>
                setPersonalOfferForm((prev) => ({
                  ...prev,
                  amount: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Rate (% p.a.)
            </div>
            <InputNumber
              style={{ width: "100%" }}
              value={personalOfferForm.rate_pa}
              min={0}
              max={100}
              onChange={(value) =>
                setPersonalOfferForm((prev) => ({
                  ...prev,
                  rate_pa: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Tenor (years)
            </div>
            <InputNumber
              style={{ width: "100%" }}
              value={personalOfferForm.tenor_years}
              min={0.25}
              max={10}
              step={0.25}
              onChange={(value) =>
                setPersonalOfferForm((prev) => ({
                  ...prev,
                  tenor_years: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Request additional documents (optional)
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {personalOfferDocuments.map((doc, index) => (
                <div
                  key={`pending-personal-doc-${index}`}
                  style={{ display: "flex", gap: 8 }}
                >
                  <Input
                    placeholder="Document name"
                    value={doc}
                    onChange={(event) =>
                      handlePersonalDocumentChange(event.target.value, index)
                    }
                  />
                  {personalOfferDocuments.length > 1 && (
                    <Button
                      type="text"
                      icon={<MinusOutlined />}
                      onClick={() => removePersonalDocument(index)}
                    />
                  )}
                  {index === personalOfferDocuments.length - 1 && (
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addPersonalDocument}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Message</div>
            <Input.TextArea
              rows={3}
              placeholder="Optional message to the borrower"
              value={personalOfferMessage}
              onChange={(event) => setPersonalOfferMessage(event.target.value)}
            />
          </div>
            </div>
          </div>
          <div className="sl-loan-modal-panel sl-loan-modal-summary">
            <h3>Offer snapshot</h3>
            <div className="sl-loan-modal-summary-item">
              <span>Requested amount</span>
              <strong>{formatCurrency(personalOfferForm.amount)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred rate</span>
              <strong>
                {personalOfferForm.rate_pa !== ""
                  ? `${personalOfferForm.rate_pa}% p.a.`
                  : "-"}
              </strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred tenor</span>
              <strong>
                {personalOfferForm.tenor_years
                  ? `${Number(personalOfferForm.tenor_years) * 12} Months`
                  : "-"}
              </strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Processing fee</span>
              <strong>10%</strong>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        className="sl-loan-action-modal"
        open={propertyOfferModal.open}
        onCancel={closePropertyOfferModal}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
              gap: 8,
            }}
          >
            <Button
              type="primary"
              loading={propertyOfferBusy}
              onClick={submitPropertyOfferUpdate}
            >
              Update offer
            </Button>
            <Button type="default" onClick={closePropertyOfferModal}>
              Cancel
            </Button>
          </div>,
        ]}
      >
        <div className="sl-loan-modal-head">
          <div className="sl-loan-modal-title">
            <div className="sl-loan-modal-mark">
              {getInitials(
                propertyOfferModal.offer
                  ? getCompanyOfferBorrowerName(propertyOfferModal.offer)
                  : "PL",
              ).slice(0, 2)}
            </div>
            <div>
              <h2>Property Term Loan Offer</h2>
              <p>Update the offer terms and document requests.</p>
            </div>
          </div>
        </div>
        <div className="sl-loan-modal-grid">
          <div className="sl-loan-modal-panel">
            <h3>Offer terms</h3>
            <div className="sl-loan-modal-fields">
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Offer amount</div>
            <InputNumber
              style={{ width: "100%" }}
              value={propertyOfferForm.amount}
              min={1000}
              formatter={(value) =>
                `S$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/S\$\s?|(,*)/g, "")}
              onChange={(value) =>
                setPropertyOfferForm((prev) => ({
                  ...prev,
                  amount: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Rate (% p.a.)
            </div>
            <InputNumber
              style={{ width: "100%" }}
              value={propertyOfferForm.rate_pa}
              min={0}
              max={100}
              onChange={(value) =>
                setPropertyOfferForm((prev) => ({
                  ...prev,
                  rate_pa: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Tenor (years)
            </div>
            <InputNumber
              style={{ width: "100%" }}
              value={propertyOfferForm.tenor_years}
              min={0.25}
              max={30}
              step={0.25}
              onChange={(value) =>
                setPropertyOfferForm((prev) => ({
                  ...prev,
                  tenor_years: value,
                }))
              }
            />
          </div>
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>
              Request additional documents (optional)
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {propertyOfferDocuments.map((doc, index) => (
                <div
                  key={`pending-property-doc-${index}`}
                  style={{ display: "flex", gap: 8 }}
                >
                  <Input
                    placeholder="Document name"
                    value={doc}
                    onChange={(event) =>
                      handlePropertyDocumentChange(event.target.value, index)
                    }
                  />
                  {propertyOfferDocuments.length > 1 && (
                    <Button
                      type="text"
                      icon={<MinusOutlined />}
                      onClick={() => removePropertyDocument(index)}
                    />
                  )}
                  {index === propertyOfferDocuments.length - 1 && (
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addPropertyDocument}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="sl-loan-modal-field full">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Message</div>
            <Input.TextArea
              rows={3}
              placeholder="Optional message to the borrower"
              value={propertyOfferMessage}
              onChange={(event) => setPropertyOfferMessage(event.target.value)}
            />
          </div>
            </div>
          </div>
          <div className="sl-loan-modal-panel sl-loan-modal-summary">
            <h3>Offer snapshot</h3>
            <div className="sl-loan-modal-summary-item">
              <span>Requested amount</span>
              <strong>{formatCurrency(propertyOfferForm.amount)}</strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred rate</span>
              <strong>
                {propertyOfferForm.rate_pa !== ""
                  ? `${propertyOfferForm.rate_pa}% p.a.`
                  : "-"}
              </strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Preferred tenor</span>
              <strong>
                {propertyOfferForm.tenor_years
                  ? `${Number(propertyOfferForm.tenor_years) * 12} Months`
                  : "-"}
              </strong>
            </div>
            <div className="sl-loan-modal-summary-item">
              <span>Processing fee</span>
              <strong>{PROPERTY_LOAN_PROCESSING_FEE_LABEL}</strong>
            </div>
          </div>
        </div>
      </Modal>
      <Box
        className="sl-loan-request-page"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="140px"
        gap="20px"
        borderRadius="10px"
      >
        <Box
          className="sl-loan-request-main"
          gridColumn={screenWidth > 1200 ? "span 9" : "span 12"}
          gridRow="span 2"
          borderRadius="10px"
          opacity="0.95"
          paddingBottom="100px"
          style={{
            overflowY: "scroll",
            height: isMobile ? "80vh" : "90vh",
            overflowX: "hidden",
            background:
              "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
            padding: "15px 15px 50px 15px",
          }}
        >
          <Box gridColumn="span 4" gridRow="span 2" opacity="0.95">
            <Box
              className="sl-loan-request-head"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              style={{ width: "100%" }}
              borderRadius="10px"
            >
              <Typography
                color={colors.grey[920]}
                variant="h5"
                fontWeight="800"
                fontFamily="Manrope, sans-serif"
                fontSize="18px"
              >
                Pending Acceptance
              </Typography>
              <div className="sl-loan-type-filter" aria-label="Loan type filter">
                {[
                  ["all", "All", "#0F172A"],
                  ["corporate", "Corporate", "#2F80ED"],
                  ["personal", "Personal", "#EC4899"],
                  ["concierge", "Concierge", "#A855F7"],
                ].map(([value, label, color]) => (
                  <button
                    key={value}
                    type="button"
                    className={activeLoanTypeFilter === value ? "is-active" : ""}
                    onClick={() => setActiveLoanTypeFilter(value)}
                  >
                    {value !== "all" ? (
                      <span className="dot" style={{ background: color }} />
                    ) : null}
                    {label}
                    <span className="count">{loanTypeCounts[value]}</span>
                  </button>
                ))}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "250px",
                }}
              >
                <label
                  htmlFor="sort-by"
                  style={{
                    marginRight: "7px",
                    marginLeft: "10px",
                    color: "#142C44CC",
                    fontWeight: "800",
                    fontSize: "13px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  Sort by:
                </label>
                <div style={{ width: "60%" }}>
                  <select
                    id="sort-by"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    style={{
                      width: "100%",
                      borderRadius: "30px",
                      color: "#0E5AA5",
                      backgroundColor: "#ECF0F5",
                      border: "1px solid #3E536733",
                      fontWeight: "600",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "13px",
                    }}
                  >
                    <option value="default">Date & Time</option>
                    <option value="loan-amount">Loan Amount</option>
                    <option value="date">Date</option>
                  </select>
                </div>
              </div>
            </Box>
            <Box gridColumn="span 4">
              <div
                className="sl-loan-grid-list"
                style={{
                  alignItems: "flex-start",
                  color: "grey",
                  width: "100%",
                  marginTop: "15px",
                }}
              >
                {pendingLoanEntries.length > 0 ? (
                  pendingLoanEntries.map(renderPendingLoanEntry)
                ) : (
                  <div style={{ width: "100%", padding: "0px 0px" }}>
                    <div
                      style={{
                        width: "100%",
                        padding: "0px 15px",
                        background: "rgba(255,255,255,0.7)",
                        borderRadius: "10px",
                        height: "150px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontFamily: "Manrope, sans-serif",
                        fontSize: "0.8em",
                        fontWeight: "600",
                        color: "#00000066",
                      }}
                    >
                      {pageSearch.trim() ? "No results found" : "No loans pending acceptance"}
                    </div>
                  </div>
                )}
                {data &&
                  data.length > 0 &&
                  data.map((item, index) => (
                    <Modal
                      className="sl-loan-action-modal sl-pending-view-offer-modal"
                      style={{}}
                      open={modalStates[item.loan_id]}
                      onCancel={() =>
                        setModalStates((prevStates) => ({
                          ...prevStates,
                          [item.loan_id]: false,
                        }))
                      }
                      width={isMobile ? "100%" : "60vw"}
                      footer={[]}
                    >
                      {(() => {
                        const corporateBorrowerName = getCorporateLoanName(item);
                        return (
                          <div className="sl-loan-modal-head">
                            <div className="sl-loan-modal-title">
                              <div className="sl-loan-modal-mark">
                                {getInitials(corporateBorrowerName).slice(
                                  0,
                                  2,
                                )}
                              </div>
                              <div>
                                <h2>Corporate Loan Offer</h2>
                                <p>
                                  Review the accepted offer for{" "}
                                  {corporateBorrowerName}.
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })()}
                      <div className="sl-offer-review-grid">
                        <div className="sl-offer-review-panel">
                          <h3>Applicant details</h3>
                          <div className="sl-offer-review-fields">
                            <div className="sl-offer-review-field wide">
                              <span>Name</span>
                              <strong>{getCorporateLoanName(item)}</strong>
                            </div>
	                            <div className="sl-offer-review-field">
	                              <span>Loan ID</span>
	                              <strong>{item.loan_id || "-"}</strong>
	                            </div>
	                            <div className="sl-offer-review-field">
	                              <span>Status</span>
	                              <em>
	                                {item.status === "pending_document_request"
	                                  ? "Pending Document Request"
	                                  : item.status
	                                    ? item.status.charAt(0).toUpperCase() +
	                                      item.status.slice(1)
	                                    : "-"}
	                              </em>
	                            </div>
	                            <div className="sl-offer-review-field wide">
	                              <span>Loan category</span>
	                              <strong>
	                                {item.type === "simple"
	                                  ? "Unsecured Business Term Loan"
	                                  : "-"}
	                              </strong>
	                            </div>
	                            <div className="sl-offer-review-field">
	                              <span>Created</span>
	                              <strong>{formatDate(item.created_at)}</strong>
	                            </div>
	                            <div className="sl-offer-review-field">
	                              <span>Updated</span>
	                              <strong>{formatDate(item.updated_at)}</strong>
	                            </div>
	                          </div>
	                        </div>
	                        <div className="sl-offer-review-panel">
	                          <h3>Offer terms</h3>
	                          <div className="sl-offer-review-fields">
	                            <div className="sl-offer-review-field wide">
	                              <span>Requested amount</span>
	                              <strong>{formatCurrency(item.offer_amount)}</strong>
	                            </div>
	                            <div className="sl-offer-review-field">
	                              <span>Preferred rate</span>
	                              <strong>
	                                {item.offer_interest_rate !== undefined &&
	                                item.offer_interest_rate !== null
	                                  ? `${(item.offer_interest_rate * 100).toFixed(
	                                      1,
	                                    )}%`
	                                  : "-"}
	                              </strong>
	                            </div>
	                            <div className="sl-offer-review-field">
	                              <span>Preferred tenor</span>
	                              <strong>
	                                {item.offer_period
	                                  ? `${item.offer_period} Month`
	                                  : "-"}
	                              </strong>
	                            </div>
	                            <div className="sl-offer-review-field">
	                              <span>Processing fee</span>
	                              <strong>
	                                {item.processing_fee !== undefined &&
	                                item.processing_fee !== null
	                                  ? `${(item.processing_fee * 100).toFixed(1)}%`
	                                  : "-"}
	                              </strong>
	                            </div>
	                            <div className="sl-offer-review-field">
	                              <span>Offer principal</span>
	                              <strong>
	                                {formatCurrency(item.offer_principal)}
	                              </strong>
	                            </div>
	                            <div className="sl-offer-review-field wide">
	                              <span>Offer revenue</span>
	                              <strong>{formatCurrency(item.offer_revenue)}</strong>
	                            </div>
	                          </div>
	                        </div>
	                      </div>
	                      <div className="sl-offer-review-panel sl-offer-review-docs">
	                        <h3>Requested files</h3>
	                        <TablePendingAcceptance
	                          parentData={data}
	                          loan_id={item.loan_id}
	                        />
	                      </div>
	                      {item.status === "pending_document_request" && (
	                        <div className="sl-offer-review-actions">
	                          <button
	                            className="sl-modal-primary-action"
	                            onMouseEnter={() => setHovered2(true)}
	                            onMouseLeave={() => setHovered2(false)}
	                            onClick={(event) =>
	                              showModalAcceptOffer(item.id, event)
	                            }
	                          >
	                            Allow Accept Offer
	                          </button>
	                          <button
	                            onMouseEnter={() => setHovered3(true)}
	                            onMouseLeave={() => setHovered3(false)}
	                            onClick={(event) =>
	                              showModalRequestDocument(item.id, event)
	                            }
	                          >
	                            Request More File
	                          </button>
	                        </div>
	                      )}
                    </Modal>
                  ))}

                <Modal
                  className="sl-loan-action-modal"
                  footer={[
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: 16,
                      }}
                    >
                      <Button
                        type="primary"
                        onClick={() =>
                          handleRequestMoreDocument(
                            offer_id,
                            documentDescriptions,
                          )
                        }
                      >
                        Submit
                      </Button>
                      <Button type="default" onClick={handleCancel}>
                        Cancel
                      </Button>
                    </div>,
                  ]}
                  open={isModalOpen}
                  // onOk={handleOk}
                  onCancel={handleCancel}
	                >
	                  <div className="sl-loan-modal-head">
	                    <div className="sl-loan-modal-title">
	                      <div className="sl-loan-modal-mark">FD</div>
	                      <div>
	                        <h2>Request More File</h2>
	                        <p>Add the document names needed from the borrower.</p>
	                      </div>
	                    </div>
	                  </div>
	                  <div className="sl-loan-modal-panel">
	                    <h3>Document request</h3>
	                  <div>
	                    {documentDescriptions.map((description, index) => (
	                      <div
                        key={index}
                        style={{
                          display: "flex",
                          width: "90%",
                          marginTop: "15px",
                        }}
                      >
                        <div style={{ width: "30%" }}>
                          <div
                            style={{
                              color: "rgba(0,0,0,0.5)",
                              fontWeight: "700",
                              marginTop: "10px",
                            }}
                          >
                            Document Name
                          </div>
                        </div>
                        <div style={{ width: "60%" }}>
                          <div>
                            <input
                              style={{
                                width: "90%",
                                padding: "8px",
                                borderRadius: "12px",
                                marginTop: "5px",
                                outline: "none",
                                border: "1px solid rgba(0,0,0,0.2)",
                              }}
                              value={description}
                              placeholder="Document Name"
                              onChange={(event) => handleChange(event, index)}
                            />
                          </div>
                        </div>
                        {documentDescriptions.length > 1 && (
                          <div style={{ width: "10%", textAlign: "right" }}>
                            <Button
                              type="default"
                              onClick={() => remove(index)}
                              style={{
                                backgroundColor: "none",
                                border: "none",
                                color: "#FF0000",
                                boxShadow: "none",
                                marginTop: "10px",
                              }}
                              icon={<MinusOutlined />}
                            >
                              Remove
                            </Button>
                          </div>
                        )}
                      </div>
                    ))}
                    <div>
                      <Button
                        type="default"
                        onClick={addMore}
                        style={{
                          backgroundColor: "none",
                          border: "none",
                          color: "#0E5AA5",
                          marginLeft: "25%",
                          boxShadow: "none",
                          marginTop: "5px",
                        }}
                        icon={<PlusOutlined style={{ marginTop: "-10px" }} />}
                      >
                        Add more
	                      </Button>
	                    </div>
	                  </div>
	                  </div>
	                </Modal>
	                <Modal
	                  className="sl-loan-action-modal"
                  footer={[
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: 16,
                      }}
                    >
                      <Button
                        type="primary"
                        onClick={() => handleAllowAcceptOffer(offer_id)}
                      >
                        Yes
                      </Button>
                      <Button type="default" onClick={handleAcceptOfferCancel}>
                        No
                      </Button>
                    </div>,
                  ]}
                  open={isModalAcceptOfferOpen}
                  // onOk={handleOk}
	                  onCancel={handleAcceptOfferCancel}
	                >
	                  <div className="sl-loan-modal-head">
	                    <div className="sl-loan-modal-title">
	                      <div className="sl-loan-modal-mark">OK</div>
	                      <div>
	                        <h2>Allow Offer Acceptance</h2>
	                        <p>Confirm the borrower can proceed with this offer.</p>
	                      </div>
	                    </div>
	                  </div>
	                  <div className="sl-loan-modal-panel">
	                    <h3>Confirmation</h3>
	                    <p style={{ margin: 0 }}>
	                      Do you want to allow the borrower to accept the offer?
	                    </p>
	                  </div>
	                </Modal>


              </div>
            </Box>
          </Box>
        </Box>
        {!isMobile ? (
          <Box
            className="sl-loan-filter-panel sl-dashboard-rail"
            gridColumn="span 3"
            gridRow="span 2"
            // backgroundColor="rgba(153, 178, 205, 0)"
            overflow="auto"
            height="90vh"
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              style={{ marginBottom: "10px" }}
            >
              <Typography
                className="sl-dashboard-section-title"
                color={colors.grey[920]}
                variant="h5"
                fontWeight="800"
                fontFamily="Manrope, sans-serif"
                fontSize="18px"
              >
                Analytics
              </Typography>
            </Box>
            <Box
              className="sl-dashboard-analytics"
              gridColumn="span 2"
              opacity="1.00"
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="200px"
              marginBottom="-2.5vh"
            >
              <Box
                width="49%"
                opacity="1.00"
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="170px"
              >
                <ContainerLineChart></ContainerLineChart>
              </Box>
              {/* <Box
                width="49%"
                opacity="1.00"
                display="flex"
                alignItems="left"
                justifyContent="left"
                height="200px"
                marginLeft="10px"
              >
                <ContainerPieChart></ContainerPieChart>
              </Box> */}
            </Box>
            <Box
              gridColumn="span 4"
              gridRow="span 2"
              backgroundColor="rgba(153, 178, 205, 0)"
              overflow="auto"
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                // borderBottom={`4px solid ${colors.primary[500]}`}
                colors={colors.grey[100]}
                p="5px"
              >
                <Typography
                  className="sl-dashboard-section-title"
                  color={colors.grey[920]}
                  variant="h5"
                  fontWeight="800"
                  fontFamily="Manrope, sans-serif"
                  fontSize="20px"
                >
                  Activity Log
                </Typography>
              </Box>
              {dataActivityLog && dataActivityLog.length > 0 ? (
                <div className="sl-activity-log">
                  {dataActivityLog.slice(0, 3).map((item, index) => (
                    <Box
                      key={index}
                      gridColumn="span 1"
                      display="flex"
                      alignItems="left"
                      justifyContent="left"
                      style={{
                        opacity:
                          index === 2
                            ? 0.6
                            : index === 3
                              ? 0.2
                              : index === 1
                                ? 0.9
                                : 1,
                        transitionDelay: `${index * 0.1}s`,
                      }}
                    >
                      <ContainerActivity
                        title={item.principal_name || "-"}
                        subtitle={item.description || "-"}
                        index={index}
                      />
                    </Box>
                  ))}
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    padding: "0px 0px",
                    marginTop: "15px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      padding: "0px 15px",
                      background: "rgba(255,255,255,0.7)",
                      borderRadius: "10px",
                      height: "48vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontFamily: "Manrope, sans-serif",
                      fontSize: "0.8em",
                      fontWeight: "600",
                      color: "#00000066",
                    }}
                  >
                    No Activity Log
                  </div>
                </div>
              )}
            </Box>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default PendingAcceptance;
